import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { isEmpty, isVersionCodeEligible } from "@swiggy-private/core-ui";
import { CardDetails } from "@swiggy-private/payment-types";
import { isCategoryInstamart } from "./Misc";

export const getSelectedCardDetails = (
    selectedCardFingerprint: string,
    cardsList: CardDetails[],
): CardDetails | null => {
    if (!selectedCardFingerprint || isEmpty(cardsList)) {
        return null;
    }

    const cardDetails = cardsList.find((card) => card.cardFingerprint === selectedCardFingerprint);

    if (!cardDetails) {
        return null;
    }

    return cardDetails;
};

export const isInstamartSaveCardMessageDisplayed = () => {
    if (!isCategoryInstamart()) {
        return false;
    }
    const NEW_ENTITY_ANDROID_VERSION = 1785;
    const NEW_ENTITY_IOS_VERSION = 810;

    const versionCode = GlobalHeaderState.getHeader(SwgyHeaderKeysList.versionCode) || "";
    const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "";
    return isVersionCodeEligible(NEW_ENTITY_ANDROID_VERSION, NEW_ENTITY_IOS_VERSION, versionCode, platform);
};
